import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection } from "@/components/layout/visualLayout";
import Reveal from "@/components/common/Reveal";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = Array.from({ length: 13 }, (_, i) => i + 1);

  return (
    <div data-testid="page-privacy">
      <PageHero
        eyebrow={`${t("nav.about")} / ${t("footer.privacy")}`}
        title={t("privacy.title")}
        subtitle={t("privacy.lead")}
        testId="privacy-hero"
      />

      <VisualSection testId="privacy-content">
        <div className="grid gap-5 max-w-3xl" data-testid="privacy-sections">
          {sections.map((n, i) => (
            <Reveal key={n} delay={i * 0.05}>
              <article className="wit-card" data-testid={`privacy-section-${n}`}>
                <h2 className="wit-heading-card">{t(`privacy.section${n}Title`)}</h2>
                <p className="wit-body">{t(`privacy.section${n}`)}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </VisualSection>
    </div>
  );
}
